<div class="login">
    <div class="login__content">
        <core-brand-logo [isNotLink]="true"></core-brand-logo>
        <div class="login__wrapper">
            <div class="maintenance">
                <svg class="maintenance__icon" height="48" width="48" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2 42 24 4l22 38Zm5.2-3h33.6L24 10Zm17-2.85q.65 0 1.075-.425.425-.425.425-1.075 0-.65-.425-1.075-.425-.425-1.075-.425-.65 0-1.075.425Q22.7 34 22.7 34.65q0 .65.425 1.075.425.425 1.075.425Zm-1.5-5.55h3V19.4h-3Zm1.3-6.1Z" />
                </svg>
                <h1 class="maintenance__primary-heading">
                    {{ 'Maintenance' | translate }}
                    <core-dark-mode-toggle class="float-end" [moonDark]="true"></core-dark-mode-toggle>
                </h1>
                <div class="col-12">
                    <p class="maintenance__paragraph mb-1">
                        {{
                            "This site is currently unavailable as maintenance is in progress. We'll be back shortly."
                                | translate
                        }}
                    </p>
                </div>
            </div>
        </div>

        <footer class="footer-login">
            <p class="footer-login__copyright" [innerHTML]="copyright"></p>
        </footer>
    </div>

    <core-demo-config-toggle></core-demo-config-toggle>
</div>
